module.exports = {
	"version": 2,
	"waiters": {
		"DeploymentSuccessful": {
			"delay": 15,
			"operation": "GetDeployment",
			"maxAttempts": 120,
			"acceptors": [
				{
					"expected": "Succeeded",
					"matcher": "path",
					"state": "success",
					"argument": "deploymentInfo.status"
				},
				{
					"expected": "Failed",
					"matcher": "path",
					"state": "failure",
					"argument": "deploymentInfo.status"
				},
				{
					"expected": "Stopped",
					"matcher": "path",
					"state": "failure",
					"argument": "deploymentInfo.status"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codedeploy-2014-10-06.waiters2.json
// module id = 1935
// module chunks = 0